export class ApiError extends Error {}

export class EnvironmentEmptyError extends ApiError {
    constructor(orgId: string, fileName: string | undefined, envName: string) {
        if(fileName) super(`Environment '${envName}' is empty so cannot be imported into file '${fileName} in org '${orgId}'.`);
        else super(`Environment '${envName}' in org '${orgId}' is empty so cannot get schema names.`);
    }
}